<template>
  <div class="common_contentBox">
    <div class="common_search">
      <el-row>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <span class="labelCopy">{{ $t('industryReport.hybblb.cxtj.bbbh') }}：</span>

          <div class="contentCopy">
            <el-input v-model="form.activityCode" :placeholder="$t('general.pec')" />
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <span class="labelCopy">{{ $t('industryReport.hdxx.hdmc') }}：</span>

          <div class="contentCopy">
            <el-input v-model="form.activityName" :placeholder="$t('general.pec')" />
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <span class="labelCopy">{{ $t('industryReport.hybblb.cxtj.bbr') }}：</span>

          <div class="contentCopy">
            <el-input v-model="form.applyUserNameOrId" :placeholder="$t('general.pec')" />
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <span class="labelCopy">{{ $t('industryReport.hybblb.cxtj.hy') }}：</span>
          <div class="contentCopy">
            <el-select v-model="form.targetIndustry" :placeholder="$t('general.ps')" clearable>
              <el-option v-for="item in industryList" :key="item.fieldKey" :label="item.fieldValue"
                         :value="item.fieldKey"
              />
            </el-select>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <span class="labelCopy">{{ $t('newApp.Attribute.bat') }}：</span>
          <div class="contentCopy">
            <el-date-picker
              v-model="form.applyTimeRange"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="-"
              :start-placeholder="$t('general.StartTime')"
              :end-placeholder="$t('general.EndTime')"
              @change="handleApplyTimeChange"
            />
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6" />
        <div class="btnBar">
          <el-button @click="onreset" plain>{{ $t('btn.Reset') }}</el-button>
          <el-button @click="searchBtn" type="primary">{{ $t('btn.Search') }}</el-button>
        </div>
      </el-row>
    </div>
    <div class="common_btnBar">
      <el-button v-if="showOperationColumn" type="primary" @click="exportExcel">{{ $t('btn.DetailExport') }}</el-button>
      <el-button type="primary" @click="biJump">{{ $t('eventList.BIFind') }}</el-button>
      <el-button v-if="showOperationColumn" type="primary" @click="overviewExport">{{ $t('btn.OverviewExport') }}</el-button>
    </div>
    <commonTable
      ref="reportListTable"
      :is-choice-flag="true"
      :whether-check-method="whetherCheckMethod"
      @handleSelectChange="handleTableSelectChange"
      @handleCheckBoxAll="handleTableCheckAllChange"
      @handleTableList="getList"
    />
    <el-dialog :visible.sync="dialogVisible" width="600px" class="activityDialog">
      <template #title>
        <div class="dialog-header">
          {{ $t('industryReport.zdchqy.name') }}
        </div>
      </template>
      <commonTable ref="activityDialogTable" />
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" type="info">
          {{ $t('btn.Close') }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import commonTable from '@/components/commonTable';
import { TableRow, TableColumns } from '@/utils/tableOptions.js';
import { newApplicationFormApi } from '../newApplicationForm/service';
import { activityQuery } from './service';
import { formatTargetObjectDisplay } from '../newApplicationForm/mixins/targetObjectMixin';
export default {
  name: 'IndustryTemplateActivitySummary',
  data () {
    return {
      dialogVisible: false,
      form: {
        activityCode: ''
      },
      industryList: [],
      selectedRows: [],
      showOperationColumn: true
    };
  },
  components: {
    commonTable
  },
  mounted () {
    this.loadTable();
    this.getActivityList();
  },
  methods: {
    getList (list) {
      const disabledList = list.map(item => {
        return this.listDataDisable(item);
      });
      this.showOperationColumn = disabledList.some(item => item === false);
      this.setReportTableColumns();
    },
    handleTableSelectChange (payload) {
      this.updateSelectedRows(payload);
    },
    handleTableCheckAllChange (payload) {
      this.updateSelectedRows(payload);
    },
    updateSelectedRows ({ records = [] }) {
      this.selectedRows = [...records];
    },

    exportExcel () {
      if (this.selectedRows.length === 0) {
        this.$message.warning(this.$t('industryReport.hybblb.tsy.qxzdcw'));
        return false;
      }
      const params = {
        templateIdList: this.selectedRows.map(item => item.templateId)
      };
      const loading = this.$loading({
        lock: true,
        text: this.$t('general.Loading'),
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      activityQuery.exportIndustrySummaryActivityList(params).then(res => {
        loading.close();
        try {
          const arrayBuffer = res.data;
          const contentDisposition = (res.headers && (res.headers['content-disposition'] || res.headers['Content-Disposition'])) || '';
          let fileName = '行业模板汇总列表.xlsx';
          if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename\*=UTF-8''(.+)|filename="?([^";]+)"?/i);
            if (fileNameMatch) {
              fileName = decodeURIComponent(fileNameMatch[1] || fileNameMatch[2]);
            }
          }
          const blob = new Blob([arrayBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, fileName);
          } else {
            const link = document.createElement('a');
            const url = window.URL.createObjectURL(blob);
            link.href = url;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(link);
          }
          this.$message.success(this.$t('general.ExportSuccess'));
        } catch (e) {
          this.$message.error(this.$t('general.ExportFailure'));
        }
      }).catch(() => {
        loading.close();
        this.$message.error(this.$t('general.ExportFailure'));
      });
    },
    overviewExport () {
      // 进度导出按当前列表筛选条件导出，无需勾选数据
      const params = JSON.parse(JSON.stringify(this.form));
      if (params.applyTimeRange) {
        delete params.applyTimeRange;
      }
      params.templateIdList = this.selectedRows.map(item => item.templateId);
      const loading = this.$loading({
        lock: true,
        text: this.$t('general.Loading'),
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      activityQuery.exportIndustryTemplateList(params).then(res => {
        loading.close();
        try {
          const arrayBuffer = res.data;
          const contentDisposition = (res.headers && (res.headers['content-disposition'] || res.headers['Content-Disposition'])) || '';
          let fileName = '行业模板活动进度列表.xlsx';
          if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename\*=UTF-8''(.+)|filename="?([^";]+)"?/i);
            if (fileNameMatch) {
              fileName = decodeURIComponent(fileNameMatch[1] || fileNameMatch[2]);
            }
          }
          const blob = new Blob([arrayBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, fileName);
          } else {
            const link = document.createElement('a');
            const url = window.URL.createObjectURL(blob);
            link.href = url;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(link);
          }
          this.$message.success(this.$t('general.ExportSuccess'));
        } catch (e) {
          this.$message.error(this.$t('general.ExportFailure'));
        }
      }).catch(() => {
        loading.close();
        this.$message.error(this.$t('general.ExportFailure'));
      });
    },
    downloadExcel (row) {
      this.selectedRows = [row];
      this.exportExcel();
    },
    // 控制复选框是否可勾选：支持按后端字段禁用，未配置时默认 activityCode 存在才可勾选
    whetherCheckMethod ({ row }) {
      let userInfo = this.$store.state.userInfo;
      const approverUserIdList = row.approverUserIdList || [];
      // 添加申请用户ID 到 approverUserIdList 中，确保申请人也有权限导出
      if (approverUserIdList.length > 0 && !approverUserIdList.includes(row.applyUserId)) {
        approverUserIdList.push(row.applyUserId);
      }
      // industrySummaryExportSuperAdmin 是超级管理员权限，approverUserIdList 是审批人和申请人列表，只要满足其中一个条件就可以导出
      return userInfo.permissionDTO.industrySummaryExportSuperAdmin || approverUserIdList.includes(userInfo.sysUser.userId);
    },
    listDataDisable (row) {
      return !this.whetherCheckMethod({ row });
    },
    getActivityList () {
      let params = [
        'report_industry' // 面向行业
      ];
      newApplicationFormApi.getActivityList(params).then(res => {
        if (res.status === '200') {
          let { data } = res;
          this.industryList = data.report_industry;
        }
      });
    },
    biJump () {
      window.open('http://ruijiebi.ruijie.com.cn/webroot/decision?rjl=oa');
    },
    check (row) {
      this.dialogVisible = true;
      this.loadTableDialog(row.activityCode);
    },
    handleApplyTimeChange (e) {
      if (e) {
        this.$set(this.form, 'startDate', e[0]);
        this.$set(this.form, 'endDate', e[1]);
      } else {
        this.$delete(this.form, 'startDate');
        this.$delete(this.form, 'endDate');
      }
    },
    onreset () {
      this.form = {
        activityCode: '', // 报备编码
        activityName: '', // 活动名称
        applyUserNameOrId: '', // 报备人
        targetIndustry: '', // 行业
        startDate: '', // 开始日期
        endDate: '' // 结束日期
      };
      this.searchBtn();
    },
    searchBtn () {
      const params = JSON.parse(JSON.stringify(this.form));
      if (params.applyTimeRange) {
        delete params.applyTimeRange;
      }
      this.$refs.reportListTable.pageData.pageNum = 1;
      this.$refs.reportListTable.getTableData({ url: 'activity/getIndustryTemplateActivitySummary', params });
    },
    setReportTableColumns () {
      const column = this.buildReportTableColumns();
      this.$nextTick(() => {
        this.$refs.reportListTable.setColumn(column, {
          page: true
        });
      });
    },
    buildReportTableColumns () {
      let tableRow = new TableRow();
      if (this.showOperationColumn) {
        tableRow.push(
          new TableColumns()
            ._data('checkboxColumn')
            ._width('60')
            ._fixed('left')
            ._others('checkbox')
        );
      };
      // 报备编码
      tableRow.push(
        new TableColumns()
          ._title(this.$t('industryReport.hybblb.cxtj.bbbh'))
          ._data('activityCode')
          ._width('140')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
                return row.activityCode ? row.activityCode : '-';
            }
          })
      );
      // 活动名称
      tableRow.push(
        new TableColumns()
          ._title(this.$t('industryReport.hdxx.hdmc'))
          ._data('activityName')
          ._width('220')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
                return row.activityName ? row.activityName : '-';
            }
          })
      );
      // 行业
      tableRow.push(
        new TableColumns()
          ._title(this.$t('industryReport.hybblb.cxtj.hy'))
          ._data('targetIndustry')
          ._width('120')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
                return row.targetIndustry ? row.targetIndustry : '-';
            }
          })
      );
      // 预计举办周期
      tableRow.push(
        new TableColumns()
          ._title(this.$t('industryReport.hdxx.yjjbzq'))
          ._data('expectPeriod')
          ._width('200')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
                return row.expectPeriod ? row.expectPeriod : '-';
            }
          })
      );
      // 主要目标对象
      tableRow.push(
        new TableColumns()
          ._title(this.$t('industryReport.hdxx.zymbdx'))
          ._data('targetObject')
          ._width('120')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
                if (!row.targetObject) return '-';
                return formatTargetObjectDisplay(row.targetObject, row.targetObjectOther, this.$t.bind(this));
            }
          })
      );
      // 举办城市
      // tableRow.push(
      //   new TableColumns()
      //     ._title(this.$t('industryReport.hdxx.jbcs'))
      //     ._data('city')
      //     ._width('120')
      // );
      // 目标客户画像
       tableRow.push(
        new TableColumns()
          ._title(this.$t('industryReport.hybblb.list.mbkhhx'))
          ._data('targetCoverageCustomerPortrait')

          ._width('120')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
                return row.targetCoverageCustomerPortrait ? row.targetCoverageCustomerPortrait : '-';
            }
          })
      );
      // 单场费用上限
      tableRow.push(
        new TableColumns()
          ._title(this.$t('industryReport.hybblb.list.dcfysx'))

          ._data('singleActivityExpenseLimit')

          ._width('120')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
                return row.singleActivityExpenseLimit ? row.singleActivityExpenseLimit : '-';
            }
          })
      );
      // 总场次
      tableRow.push(
        new TableColumns()
          ._title(this.$t('industryReport.hybblb.list.zcc'))

          ._data('activityTotalCount')

          ._width('80')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
                return row.activityTotalCount ? row.activityTotalCount : '-';
            }
          })
      );
      // 重点落地区域
      tableRow.push(
        new TableColumns()
          ._title(this.$t('industryReport.hybblb.list.zdldqy'))
          ._width('120')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
            if (!row.activityCode) {
                return '-';
              }
              return (
                <div>
                  <el-button type="text" onClick={() => { this.check(row); }}>{ this.$t('btn.View') }</el-button>
                </div>
              );
            }
          })
      );
      // 拟邀请总人数
      tableRow.push(
        new TableColumns()
          ._title(this.$t('industryReport.hybblb.list.nyqzrs'))
          ._data('inviterNum')

          ._width('120')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
                return row.inviterNum ? row.inviterNum : '-';
            }
          })
      );
      // 活动工具包
      tableRow.push(
        new TableColumns()
          ._title(this.$t('industryReport.hybblb.list.hdgjb'))
          ._offOverFlow(true)
          ._data('activityToolkit')
          ._width('120')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
                if (!row.activityToolkit) {
                  return '-';
                }
                return (
                  <span class="activity-toolkit" onClick={() => {
                    if (row.activityToolkit) {
                      window.open(row.activityToolkit);
                    }
                  }}>{row[column.property]}</span>
                );
              }
          })
      );
      // 行业报备人
      tableRow.push(
        new TableColumns()
          ._title(this.$t('industryReport.hybblb.list.hybbr'))

          ._data('applyUserName')
          ._width('120')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
                return row.applyUserName ? row.applyUserName : '-';
            }
          })
      );
      // 报备时间
      tableRow.push(
        new TableColumns()
          ._title(this.$t('industryReport.hybblb.list.bbsj'))

          ._data('createTime')

          ._width('150')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
                return row.createTime ? row.createTime : '-';
            }
          })
      );
      // 区域报备总场次
      tableRow.push(
        new TableColumns()
          ._title(this.$t('industryReport.hybblb.list.qybbzcc'))

          ._data('areaReportTotalCount')
          ._width('120')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
                return row.areaReportTotalCount ? row.areaReportTotalCount : '-';
            }
          })
      );
      // 报备审批通过场次
      tableRow.push(
        new TableColumns()
          ._title(this.$t('industryReport.hybblb.list.bbsptgcc'))

          ._data('reportApprovalApprovedCount')
          ._width('140')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
                return row.reportApprovalApprovedCount ? row.reportApprovalApprovedCount : '-';
            }
          })
      );
      // 报备转申请场次
      tableRow.push(
        new TableColumns()
          ._title(this.$t('industryReport.hybblb.list.bbzsqcc'))
          ._data('reportChangeApplicationSession')
          ._width('120')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
                return row.reportChangeApplicationSession ? row.reportChangeApplicationSession : '-';
            }
          })
      );
      // 未报备申请场次
      tableRow.push(
        new TableColumns()
          ._title(this.$t('industryReport.hybblb.list.wbbsqcc'))

          ._data('notReportChangeApplicationSession')
          ._width('150')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
                return row.notReportChangeApplicationSession ? row.notReportChangeApplicationSession : '-';
            }
          })
      );
      // 报备总预算
      tableRow.push(
        new TableColumns()
          ._title(this.$t('industryReport.hybblb.list.bbzys'))

          ._data('reportBudgetAmount')
          ._width('150')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
                return row.reportBudgetAmount ? row.reportBudgetAmount : '-';
            }
          })
      );
      // 申请总金额
      tableRow.push(
        new TableColumns()
          ._title(this.$t('industryReport.hybblb.list.sqzje'))

          ._data('totalAmountApplied')
          ._width('150')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
                return row.totalAmountApplied ? row.totalAmountApplied : '-';
            }
          })
      );
      // 剩余可申请金额
      tableRow.push(
        new TableColumns()
          ._title(this.$t('industryReport.hybblb.list.syksqje'))

          ._data('remainBudgetAmount')
          ._width('150')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
                return row.remainBudgetAmount ? row.remainBudgetAmount : '-';
            }
          })
      );
      if (this.showOperationColumn) {
        // 操作
        tableRow.push(
          new TableColumns()
            ._width('60')
            ._title(this.$t('general.Operation'))
            ._fixed('right')
            ._cellType('customDom')
            ._cellData({
              formater: ({ row, column }) => {
                return (
                  <div>
                    {this.listDataDisable(row) ? '--' : <el-button type="text" onClick={() => { this.downloadExcel(row); } }>{this.$t('general.Download')}</el-button>}
                  </div>
                );
              }
            })
        );
      }
      return tableRow._cols();
    },
    loadTable () {
      let column = this.buildReportTableColumns();
      this.$nextTick(() => {
        this.$refs.reportListTable.setColumn(column, {
          page: true
        });
        this.$refs.reportListTable.loadTable({
          url: 'activity/getIndustryTemplateActivitySummary',
          listKey: 'resultList',
          params: {}
        });
      });
    },
    loadTableDialog (activityCode) {
      let tableRow = new TableRow();
      tableRow.push(
        new TableColumns()
          ._title(this.$t('industryReport.hybblb.cxtj.qymc'))
          ._data('regionName')
          ._width('200')
           ._align('center')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('industryReport.zdchqy.jycc'))
          ._data('suggestedSessions')
          ._width('200')
           ._align('center')
      );
      let column = tableRow._cols();
      this.$nextTick(() => {
        this.$refs.activityDialogTable.setColumn(column, {
          page: false
        });
        this.$refs.activityDialogTable.loadTable({
          url: '/activity/getIndustryHeadquartersActivitySummaryLandingArea',
          listKey: 'resultList',
          params: {
            activityCode
          }
        });
      });
    }
  }

};
</script>
<style scoped>
.dialog-header {
  text-align: center; /* 文字水平居中 */
  font-size: 18px;
    /* line-height: 16px; */
    color: #5B646E;
  width: 100%;
}
.activity-toolkit{
  color: #508DB4;
  cursor: pointer;
}
.el-col > .labelCopy{
  width: 100px !important;
}
.el-col > .contentCopy {
  margin-left: 100px !important;
}
</style>
